<app-modules [modulesURL]="modulesURL" [modulesPerPage]="6" [currentUserIsAdmin]="currentUserIsAdmin" [isUserModulesControl]="true"></app-modules>
